import { render, staticRenderFns } from "./AssignPersonalPanel.vue?vue&type=template&id=1a651165"
import script from "./AssignPersonalPanel.vue?vue&type=script&lang=js"
export * from "./AssignPersonalPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports